import { inject } from '@angular/core';
import {
  CanActivateChildFn,
  CanActivateFn,
  CanMatchFn,
  Router,
} from '@angular/router';
import { AuthService } from '../services/auth.service';

export const loginUrl = '/seguridad/iniciar';

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const authActivateGuard: CanActivateFn = (route, state) => {
  const router = inject(Router);
  const authSrv = inject(AuthService);
  if (authSrv.verify()) {
    return true;
  }
  router.navigate([loginUrl]);
  return false;
};

// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const authMatchGuard: CanMatchFn = (route, segments) => {
  const router = inject(Router);
  const authSrv = inject(AuthService);
  if (authSrv.verify()) {
    return true;
  }
  router.navigate([loginUrl]);
  return false;
};

export const authActivateChildGuard: CanActivateChildFn = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  childRoute,
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  state
) => {
  const router = inject(Router);
  const authSrv = inject(AuthService);
  if (authSrv.verify()) {
    return true;
  }
  router.navigate([loginUrl]);
  return false;
};
